export const isDev = (): boolean => process.env.NODE_ENV === 'development';
export const isStaging = (): boolean => process.env.NEXT_PUBLIC_RELEASE_STAGE === 'staging';
export const isProduction = (): boolean => process.env.NEXT_PUBLIC_RELEASE_STAGE === 'production';
